import styled from "styled-components";
import { colors } from "styles/theme";

export const Container = styled.div`
  width: 100%;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const UploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid ${colors.neutral_light};
  border-radius: 8px;
  padding: 1rem;
  background: ${colors.neutral_light};
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: white;
  border: 1px solid ${colors.neutral_light};
  border-radius: 6px;
  transition: all 0.2s ease;
  gap: 0.75rem;

  &:hover {
    border-color: ${colors.neutral_medium};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
`;

export const FilePreview = styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  overflow: hidden;
`;

export const DocumentIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.neutral_light};
  border-radius: 4px;

  svg {
    width: 24px;
    height: 24px;
    path {
      stroke: ${colors.neutral_medium};
    }
  }
`;

export const FileName = styled.div`
  font-weight: 500;
  color: ${colors.neutral_darkest};
  margin-bottom: 0.25rem;
  word-break: break-word;

  .extension {
    font-size: 0.75rem;
    color: ${colors.neutral_medium};
    font-weight: normal;
    margin-left: 0.25rem;
  }
`;

export const FileSize = styled.div`
  font-size: 0.875rem;
  color: ${colors.neutral_medium};
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(245, 41, 41, 0.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ErrorText = styled.div`
  color: ${colors.secondary_four};
  font-size: 0.875rem;
  margin-top: 0.5rem;
`; 